// Desktop mega menu (WAI-ARIA APG "Disclosure (Show/Hide)" pattern)
export default function initMegaMenu() {
  const megaMenu = document.querySelector('.mega-menu') as HTMLElement | null

  if (!megaMenu) {
    return
  }

  const items = Array.from(megaMenu.querySelectorAll('.mega-menu-item')) as HTMLElement[]

  const getTrigger = (item: HTMLElement) => item.querySelector('.mega-menu-trigger') as HTMLButtonElement | null
  const getPanel = (item: HTMLElement) => item.querySelector('.mega-menu-panel') as HTMLElement | null

  const closeItem = (item: HTMLElement) => {
    getTrigger(item)?.setAttribute('aria-expanded', 'false')
    const panel = getPanel(item)
    if (panel) {
      panel.hidden = true
    }
  }

  const openItem = (item: HTMLElement) => {
    getTrigger(item)?.setAttribute('aria-expanded', 'true')
    const panel = getPanel(item)
    if (panel) {
      panel.hidden = false
    }
  }

  const closeAllExcept = (exception?: HTMLElement) => {
    items.forEach((item) => {
      if (item !== exception) {
        closeItem(item)
      }
    })
  }

  items.forEach((item) => {
    const trigger = getTrigger(item)
    if (!trigger) {
      return
    }

    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true'
      closeAllExcept(item)

      if (isOpen) {
        closeItem(item)
      } else {
        openItem(item)
      }
    })

    // Escape closes the open flyout and returns focus to its trigger
    item.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
        closeItem(item)
        trigger.focus()
      }
    })

    // Tabbing past the last focusable element inside the item closes it
    // (same relatedTarget/focusout technique as the GOV.UK Design System mega menu)
    item.addEventListener('focusout', (event) => {
      const nextFocusTarget = event.relatedTarget as Node | null
      if (!nextFocusTarget || !item.contains(nextFocusTarget)) {
        closeItem(item)
      }
    })
  })

  // Clicking anywhere outside the whole nav closes any open flyout
  document.addEventListener('click', (event) => {
    if (!megaMenu.contains(event.target as Node)) {
      closeAllExcept()
    }
  })
}
